<script>
  import CompanyAwareMixin from '../base/CompanyAwareMixin.vue'
  import CreateView from '../base/CreateView.vue'
  import SubEditView from '../base/SubEditView.vue'
  import FormInput from '../form/form-input.vue'
  import FormTextarea from '../form/form-textarea.vue'
  import FormLookup from '../form/form-lookup.vue'
  import FormDatepicker from '../form/form-datepicker.vue'
  import FormSelect from '../form/form-select.vue'
  import FormTaxrate from '../form/form-taxrate'

  export default {
    components: {
      CreateView,
      SubEditView,
      FormInput,
      FormTextarea,
      FormLookup,
      FormDatepicker,
      FormSelect,
      FormTaxrate,
    },
    mixins: [
      CompanyAwareMixin,
    ],
    data () {
      return {
        invoiceType: [
          {value: 1, text: 'DE VAT - Inner German with VAT.'},
          {value: 2, text: 'EU VAT - Inner EU with 0% VAT (reverse charge).'},
          {value: 3, text: 'NO VAT - Outside EU with 0% VAT.'},
        ],
        store: 'invoice/create'
      }
    },
    methods: {
      childAdded (childName) {
        this.$store.dispatch('invoice/create/' + childName + '/updateItem', {
          sorting: this.$store.getters['invoice/update/childSlots'].length
        })
      },
      reorderChilden () {
        this.$store.getters['invoice/create/childSlots'].map((childName, index) => {
          this.$store.dispatch('invoice/create/' + childName + '/updateItem', {
            sorting: index + 1
          })
        })
      },
    },
    created () {
      console.log(this.$store.getters['apiInformation'])
      console.log(this.$store.getters['invoice/create/item'])
    }
  }
</script>
<template>
  <create-view store="invoice" translation-root="invoice" update-route="InvoiceUpdate" v-slot:default="invoiceProps" @reset="resetted">
    <form-input :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="invoiceNr" type="number" class="col-3"></form-input>
    <form-select :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="type" :options="invoiceType" class="col-3"></form-select>
    <form-lookup :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="customer" class="col-3">
      <template v-slot:selected-item="customerProps">
        {{customerProps.item.addr1}}
        {{customerProps.item.addr2}}
      </template>
      <template v-slot:item="customerProps">
        {{customerProps.item.addr1}}<br/>
        {{customerProps.item.addr2}}
      </template>
    </form-lookup>
    <form-lookup :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="project" class="col-3">
      <template v-slot:selected-item="projectProps">
        {{projectProps.item.projectnr}}
        {{projectProps.item.name}}
      </template>
      <template v-slot:item="projectProps">
        {{projectProps.item.projectnr}}
        {{projectProps.item.name}}
      </template>
    </form-lookup>
    <form-datepicker :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="issueDate" format="YYYY-MM-DD" class="col-3"></form-datepicker>
    <form-datepicker :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="mailDate" format="YYYY-MM-DD" class="col-3"></form-datepicker>
    <form-datepicker :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="incomingDate" format="YYYY-MM-DD" class="col-3"></form-datepicker>
    <form-textarea  :store="invoiceProps.store" :translation-root="invoiceProps.translationRoot" prop-name="freeText" class="col-12"></form-textarea>
    <sub-edit-view
            :store="invoiceProps.store"
            translation-root="invoicepos"
            :disabled="invoiceProps.isLoading"
            class="container-fluid"
            @add-child="childAdded"
            @remove-child="reorderChilden"
            @moved-child="reorderChilden"
    >
      <template v-slot:header="header">
        <b-row :class="header.className + ' header'">
          <strong class="col-1" :title="$t(`${header.translationRoot}.sorting.description`)">{{ $t(`invoicepos.sorting.label`)}}</strong>
          <strong class="col-1" :title="$t(`${header.translationRoot}.amount.description`)">{{ $t(`invoicepos.amount.label`)}}</strong>
          <strong class="col-2" :title="$t(`${header.translationRoot}.singleprice.description`)">{{ $t(`invoicepos.singleprice.label`)}}</strong>
          <strong class="col-1" :title="$t(`${header.translationRoot}.taxrate.description`)">{{ $t(`invoicepos.taxrate.label`)}}</strong>
          <strong class="col-7" :title="$t(`${header.translationRoot}.description.description`)">{{ $t(`invoicepos.description.label`)}}</strong>
        </b-row>
      </template>
      <template v-slot:default="invoicePosProps">
        <b-row :class="invoicePosProps.className">
          <form-input :store="invoicePosProps.store" :translation-root="invoicePosProps.translationRoot" prop-name="sorting" type="number" class="col-1" :hide-label="true"></form-input>
          <form-input :store="invoicePosProps.store" :translation-root="invoicePosProps.translationRoot" prop-name="amount" type="number" class="col-1" :hide-label="true"></form-input>
          <form-input :store="invoicePosProps.store" :translation-root="invoicePosProps.translationRoot" prop-name="singleprice" type="number" class="col-2" :hide-label="true"></form-input>
          <form-taxrate :store="invoicePosProps.store" :translation-root="invoicePosProps.translationRoot" prop-name="taxrate" class="col-1" :hide-label="true"></form-taxrate>
          <form-textarea :store="invoicePosProps.store" :translation-root="invoicePosProps.translationRoot" prop-name="description" class="col-7" :hide-label="true" :rows="1"></form-textarea>
        </b-row>
      </template>
    </sub-edit-view>
  </create-view>
</template>
